'use client';

import React, { useEffect } from 'react';
import { AuthEventKeys, AuthEvents, LoginScreen } from '@/auth';
import { createEventBus } from '@/shared/utils';
import { BackgroundWavesScreen } from '@/shared/ui';
import { Auth as AuthDict } from '@/shared/i18n';
import { useFirebaseAuth } from '@/shared/hooks';
import { useRouter } from 'next/navigation';

interface NewPassowrdContainerProps {
  dict: AuthDict; // Definisce la prop dict come di tipo Auth
}

function NewPassowrdContainer({ dict }: NewPassowrdContainerProps) {
  const authEventBus = createEventBus<AuthEvents>('auth-scope');
  const firebaseAuth = useFirebaseAuth();
  const router = useRouter();

  // Funzione di callback per gestire l'evento
  const handleGoLogin = () => {
    router.push('/auth/login');
  };

  useEffect(() => {
    authEventBus.emit(AuthEventKeys.newPassword.view, undefined);
    authEventBus.on(AuthEventKeys.login.go, handleGoLogin);

    // Cleanup: disiscriviamo l'evento utilizzando la stessa funzione di callback
    return () => {
      authEventBus.on(AuthEventKeys.login.go, handleGoLogin);
    };
  }, [authEventBus]);

  // Rendi il componente solo quando l'evento è stato gestito
  if (!firebaseAuth) {
    return null; // Oppure puoi mostrare un loading spinner se preferisci
  }

  return (
    <>
      <div className="flex z-10 flex-col self-center max-w-[600px] w-full gap-4">
        <LoginScreen eventBus={authEventBus} dict={dict} auth={firebaseAuth} />
      </div>
      <BackgroundWavesScreen eventBus={authEventBus} />
    </>
  );
}

export default NewPassowrdContainer;
